<div *ngIf="isLoading" class="text-center p-4">
  <i class="fa fa-spinner fa-spin fa-2x"></i>
</div>

<div *ngIf="!isLoading && template" class="template-view-container">

  <!-- Header -->
  <div class="template-view-header">
    <button class="btn btn-outline-secondary btn-sm" (click)="onBack()">
      <i class="fa fa-arrow-left"></i> {{ 'BACK' | translate }}
    </button>

    <div class="template-title-section">
      <div class="title-row">
        <h4>{{ template.Name }}</h4>
        <span class="status-badge" [class.active]="template.IsActive" [class.inactive]="!template.IsActive">
          {{ (template.IsActive ? 'ACTIVE' : 'INACTIVE') | translate }}
        </span>
        <span class="version-badge">v{{ template.Version }}</span>
      </div>
      <p *ngIf="template.Description" class="template-description">{{ template.Description }}</p>
    </div>
  </div>

  <!-- Sections -->
  <div class="template-view-body">
    <div *ngIf="template.Sections.length === 0" class="empty-state">
      {{ 'NO_SECTIONS_FOUND' | translate }}
    </div>

    <div *ngFor="let section of template.Sections; let si = index" class="section-card">
      <div class="section-card-header">
        <div class="section-number">{{ si + 1 }}</div>
        <div class="section-heading">
          <h5>
            {{ section.Title }}
            <span *ngIf="section.IsRequired" class="required">*</span>
          </h5>
          <p *ngIf="section.Description">{{ section.Description }}</p>
        </div>
      </div>

      <div class="section-card-body">
        <div *ngIf="section.Questions.length === 0" class="text-muted small">
          {{ 'NO_QUESTIONS_IN_SECTION' | translate }}
        </div>

        <table *ngIf="section.Questions.length > 0" class="table table-condensed table-hover template-question-table">
          <thead>
            <tr>
              <th class="question-number-column">#</th>
              <th class="question-text-column">{{ 'QUESTION' | translate }}</th>
              <th class="question-type-column">{{ 'TYPE' | translate }}</th>
              <th class="participant-column">{{ 'VISIBILITY' | translate }}</th>
              <th class="participant-column">{{ 'CAN_ANSWER' | translate }}</th>
              <th class="required-column">{{ 'REQUIRED' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let question of section.Questions; let qi = index">
              <td class="text-muted small question-number-column">{{ qi + 1 }}</td>
              <td class="question-text-column">
                <span [title]="question.QuestionText">{{ question.QuestionText }}</span>
                <ng-container *ngIf="question.QuestionType === QuestionType.Likert5 && (question.LikertLowLabel || question.LikertHighLabel)">
                  <br />
                  <small class="text-muted">
                    {{ question.LikertLowLabel }} → {{ question.LikertHighLabel }}
                  </small>
                </ng-container>
              </td>
              <td class="question-type-column">
                <span class="badge" [ngClass]="getQuestionTypeClass(question.QuestionType)">
                  {{ getQuestionTypeLabelKey(question.QuestionType) | translate }}
                </span>
              </td>
              <td class="participant-column">
                <span *ngIf="question.IsManagerVisible" class="badge badge-primary m-r-1">
                  {{ 'MANAGER' | translate }}
                </span>
                <span *ngIf="question.IsEmployeeVisible" class="badge badge-info">
                  {{ 'EMPLOYEE' | translate }}
                </span>
              </td>
              <td class="participant-column">
                <span *ngIf="question.ManagerCanAnswer" class="badge badge-primary m-r-1">
                  {{ 'MANAGER' | translate }}
                </span>
                <span *ngIf="question.EmployeeCanAnswer" class="badge badge-info">
                  {{ 'EMPLOYEE' | translate }}
                </span>
              </td>
              <td class="text-center required-column">
                <i *ngIf="question.IsRequired" class="fa fa-check text-success"></i>
                <i *ngIf="!question.IsRequired" class="fa fa-minus text-muted"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>
